export function fn() {
    //console.log("CREATING BOOTSCREEN")
    const bootElement = document.createElement("div")
    bootElement.classList.add("boot")
    document.body.appendChild(bootElement)
}